const UNREADABLE = new Set(["", "none", "null", "undefined", "[object object]", "nan"]);
const FALLBACK_NAME = "Un operatore Housetag";

const ACTION_BY_KIND = {
  payment_request: "ha inviato una richiesta di pagamento",
  entity_fee_request: "ha inviato una richiesta di pagamento",
  documents_request: "ha richiesto un'integrazione documenti",
  documents_received: "ha caricato un documento",
  documents_integrated: "ha caricato un documento",
  send_back: "ha rimandato indietro la pratica",
  rilavora: "ha riaperto la pratica per rilavorazione",
};

export const isReadableText = (v) =>
  typeof v === "string" && !UNREADABLE.has(v.trim().toLowerCase());

const actionForKind = (kind = "") => {
  if (ACTION_BY_KIND[kind]) return ACTION_BY_KIND[kind];
  if (/pay|fee|bollett|pagament/i.test(kind)) return ACTION_BY_KIND.payment_request;
  return "ha eseguito un'azione sulla pratica";
};

export const resolveAuthorName = (m, people = []) => {
  const n = (m?.author_name || "").trim();
  if (n && !n.includes("@") && !/^sistema/i.test(n)) return n;
  const p = people.find((u) => u.id && u.id === m?.author_id);
  return p?.display_name || FALLBACK_NAME;
};

export const messageDisplayText = (m, people = []) => {
  if (isReadableText(m?.body)) return m.body;
  if (isReadableText(m?.text)) return m.text;
  return `${resolveAuthorName(m, people)} ${actionForKind(m?.kind)}`;
};
